/**
 * InfinitSales - porta de entrada do CRM embutido (/embed, 2026-10-22).
 *
 * O painel parceiro abre esta rota num iframe. Ela avisa que está pronta
 * (só o tipo da mensagem, sem dado) e espera a sessão curta que o servidor
 * do painel pediu com a chave dele. Sessão válida vira a sessão da aba e a
 * tela pedida abre (services/global/embedSession.js). Mensagem de qualquer
 * outra origem, ou token que não seja de sessão embutida, é ignorada.
 */
import React, { useEffect, useState } from 'react';
import { EMBED_MSG, sessionFromMessage } from '../../utils/embed';
import { establishEmbedSession } from '../../services/global/embedSession';

const EmbedBridge = () => {
  const [erro, setErro] = useState(null);

  useEffect(() => {
    let abrindo = false;
    const onMessage = async (event) => {
      const sessao = sessionFromMessage(event);
      if (!sessao || abrindo) return;
      abrindo = true;
      try {
        await establishEmbedSession(sessao);
      } catch (e) {
        abrindo = false;
        setErro('Não foi possível abrir o CRM. Recarregue a página do painel.');
      }
    };
    window.addEventListener('message', onMessage);
    try {
      window.parent.postMessage({ type: EMBED_MSG.READY }, '*');
    } catch {
      /* sem janela-mãe: esta rota só faz sentido dentro do painel */
    }
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', backgroundColor: '#ffffff', color: '#667781',
      fontSize: 14, padding: 24, textAlign: 'center',
    }}>
      {erro || 'Abrindo o CRM...'}
    </div>
  );
};

export default EmbedBridge;
